module.exports = __webpack_public_path__ + "static/media/office16.5e5968fe.jpg";